import Axios from 'axios'

const WITH_API_STAGE = ['stage', 'local'].includes(
  process.env.REACT_APP_ENV ?? ''
)

export const LOCAL_BASE_URL = 'https://api.stage.cora.com.br'
export const PROD_BASE_URL = 'https://api.cora.com.br'

export default Axios.create({
  baseURL: WITH_API_STAGE ? LOCAL_BASE_URL : PROD_BASE_URL,
})
